import Vue from 'vue'
import axios from 'axios'
import wait from '@/wait'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

const http = axios.create();
http.interceptors.request.use(config => {
    wait.start("loading.everything");
    return config;
}, error => {
    wait.end("loading.everything");
    return Promise.reject(error);
});

http.interceptors.response.use(response => {
    wait.end("loading.everything");
    return response;
}, error => {
    wait.end("loading.everything");
    return Promise.reject(error);
});

export default http;